import { IFileUploadResponse, IPodcastResponse, IPresignResponse } from "../types/podcastType";

import axios, { AxiosResponse } from "axios";
import { Config } from "../config";
import apiClient from "./apiClient";

export const getAllPodcasts = async (params: {
  email: string;
}): Promise<IPodcastResponse> => {
  const response = await apiClient.instance.post<IPodcastResponse>(
    Config.endPoint.podcasts,
    params,
  );
  return response.data;
};

// Step 1: get a presigned S3 URL. Step 2: PUT the file directly to S3.
// Returns the public URL of the uploaded file.
export const uploadFile = async (params: {
  file: File;
}): Promise<IFileUploadResponse> => {
  const { file } = params;

  const presignRes = await apiClient.instance.post<IPresignResponse>(
    Config.endPoint.uploadFileS3Presign,
    {
      filename: file.name,
      contentType: file.type || "audio/mpeg",
      folder: "podcasts",
    },
  );

  const { uploadUrl, publicUrl } = presignRes.data;

  await axios.put(uploadUrl, file, {
    headers: { "Content-Type": file.type || "audio/mpeg" },
  });

  return { success: true, publicUrl };
};

export const uploadPodcast = async (params: {
  title: string;
  description: string;
  url: string;
  duration: string;
  isProPodcast: boolean;
  podcastType?: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<any>(
    Config.endPoint.uploadPodcast,
    params,
  );
  return response;
};
